import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { IconZoomIn, IconZoomOut, IconClose } from 'components/Icons';

class ZoomControls extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentZoom: 1
    };
  }

  shouldComponentUpdate(newProps, newState) {
    return this.state.currentZoom !== newState.currentZoom;
  }

  render() {
    return (
      <div className="syos-zoom-controls">
        <button
          className="syos-zoom-controls__action"
          onClick={() => this.props.panZoomInstance.zoomIn()}
          title="Zoom in"
        >
          <IconZoomIn />
        </button>
        <button
          className="syos-zoom-controls__action"
          onClick={() => this.props.panZoomInstance.resetZoom()}
          title="Reset Zoom"
        >
          <IconClose />
        </button>
        <button
          className="syos-zoom-controls__action"
          onClick={() => this.props.panZoomInstance.zoomOut()}
          title="Zoom out"
        >
          <IconZoomOut />
        </button>
      </div>
    );
  }
}

ZoomControls.propTypes = {
  panZoomInstance: PropTypes.object
};

export default ZoomControls;



// WEBPACK FOOTER //
// ./src/javascripts/components/ZoomControls.js